import SrProcessItem from "./index.vue";

SrProcessItem.install = function(Vue) {
  Vue.component(SrProcessItem.name, SrProcessItem);
};

export default SrProcessItem;



// WEBPACK FOOTER //
// ./packages/SrProcessItem/index.js